import React from 'react';
import { Tooltip } from 'react-bootstrap';
import { Translation } from 'react-i18next';
export const TOOLTIPS = {
    PROCESSED: (React.createElement(Tooltip, { style: { zIndex: 99999 }, id: "tooltip_disabled_select" },
        React.createElement(Translation, null, (t) => t('ACCESSORIALS_TOOLTIP_PROCESSED')))),
    UNITS: (React.createElement(Tooltip, { id: "units", style: { zIndex: 99999 } },
        React.createElement(Translation, null, (t) => t('ACCESSORIALS_TOOLTIP_UNITS')))),
    RATE: (React.createElement(Tooltip, { id: "rate", style: { zIndex: 99999 } },
        React.createElement(Translation, null, (t) => t('ACCESSORIALS_TOOLTIP_RATE')))),
    SHIPPER_NOTES: (React.createElement(Tooltip, { id: "note", style: { zIndex: 99999 } },
        React.createElement(Translation, null, (t) => t('ACCESSORIALS_TOOLTIP_SHIPPER_NOTES')))),
    MISSING_DOCS: (React.createElement(Tooltip, { id: "missing_accessorial_docs", style: { zIndex: 99999 } },
        React.createElement(Translation, null, (t) => t('MISSING_ACCESSORIAL_DOCS')))),
    MISSING_EQUIPMENT: (React.createElement(Tooltip, { id: "missing_equipment", style: { zIndex: 99999 } },
        React.createElement(Translation, null, (t) => t('NOT_APPLIED_TO_AN_EQUIPMENT')))),
    SHIPPER_CHANGED: (React.createElement(Tooltip, { id: "shipper_changed", style: { zIndex: 99999 } },
        React.createElement(Translation, null, (t) => t('SHIPPER_CHANGED_NOTE')))),
    NO_CARRIER_ASSIGNED_INFO: (React.createElement(Tooltip, { id: "no_carrier_assigned", style: { zIndex: 99999 } },
        React.createElement(Translation, null, (t) => t('NO_CARRIER_ASSIGNED_INFO_NOTE')))),
    EMPTY_TOOLTIP: React.createElement(Tooltip, { id: "empty_tooltip_for_buttons", content: "" }),
};
